export default __webpack_public_path__ + "AngloCandidatosUpload_desenvolvimento.xlsx";